import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalCodeQuestionPage } from './modal-code-question.page';

const routes: Routes = [
  {
    path: '',
    component: ModalCodeQuestionPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalCodeQuestionPageRoutingModule {}
